<app-nav></app-nav>
<app-top-header></app-top-header>

<div class="ParentSectionSection_Components_HTally">
  <div class="Body_ParentSectionSection_Components_HTally">
    <div class="InnerPart_Body_Renter_Htally">
      <div class="Parent_ActivityList_Dashboard TabsSection">
        <div class="InnerBodyOfComponents">
          <div class="TabsHeader">
            <div class="RemainActivityList_Tab_Button">
              <button *ngIf="canShowTab('Transaction')" (click)="selectTab('Transaction')" [class.active]="activeTab === 'Transaction'">{{ 'transaction.paymentTab' | t:'Payment' }} <span></span></button>
              <button *ngIf="canShowTab('Expense')" (click)="selectTab('Expense')" [class.active]="activeTab === 'Expense'">{{ 'transaction.expenseTab' | t:'Expense' }} <span></span></button>
            </div>

            <div class="TabsActions" *ngIf="activeTab === 'Transaction' || activeTab === 'Expense'">
              <button class="FilterBTN" [class.active-filter]="isFilterActive()" type="button" (click)="toggleFilter()">{{ 'common.filter' | t:'Filter' }}</button>
              <button *ngIf="canShowCreateButton()" class="PositiveBTN" type="button" (click)="activeTab === 'Transaction' ? openMakePayment() : openCreateExpense()">
                {{ activeTab === 'Transaction' ? ('transaction.addPayment' | t:'Add Payment') : ('transaction.addExpense' | t:'Add Expense') }}
              </button>
            </div>
          </div>

          <div *ngIf="activeTab === 'Transaction' && canShowTab('Transaction')" class="RemainActivityList_tab_content">
            <app-payment-list></app-payment-list>
          </div>

          <div *ngIf="activeTab === 'Expense' && canShowTab('Expense')" class="RemainActivityList_tab_content">
            <app-expense-list></app-expense-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-filter-modal
  *ngIf="showFilter && ((activeTab === 'Transaction' && canShowTab('Transaction')) || (activeTab === 'Expense' && canShowTab('Expense')))"
  [fields]="activeTab === 'Transaction' ? paymentFilterFields : expenseFilterFields"
  [value]="activeTab === 'Transaction' ? paymentFilterValues : expenseFilterValues"
  (apply)="applyFilters($event[0], $event[1])"
  (reset)="resetFilters()"
  (close)="toggleFilter()"
></app-filter-modal>
